import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = '/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setMessage({ type: 'success', text: '✅ Falls die E-Mail existiert, wurde ein Link gesendet.' });
    } catch (err) {
      setMessage({ type: 'error', text: 'Ein Fehler ist aufgetreten.' });
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: '420px', margin: '4rem auto', padding: '0 1rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <div style={{ fontSize: '3rem' }}>🔑</div>
        <h1 style={{ color: '#4c51bf', marginTop: '0.5rem' }}>Passwort vergessen</h1>
        <p style={{ color: '#718096' }}>Wir senden dir einen Reset-Link per E-Mail</p>
      </div>

      <div className="card">
        <input
          type="email"
          placeholder="Deine E-Mail Adresse"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        />

        {message && (
          <div className={`message message-${message.type}`}>{message.text}</div>
        )}

        <button className="btn-primary" style={{ width: '100%' }} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Sende...' : 'Reset-Link senden'}
        </button>

        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <Link to="/login" style={{ color: '#4c51bf', fontSize: '0.9rem' }}>
            Zurück zum Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;